import { render, staticRenderFns } from "./ConfrontationsByRivalModal.vue?vue&type=template&id=c581f2d8"
import script from "./ConfrontationsByRivalModal.vue?vue&type=script&lang=js"
export * from "./ConfrontationsByRivalModal.vue?vue&type=script&lang=js"
import style0 from "./ConfrontationsByRivalModal.vue?vue&type=style&index=0&id=c581f2d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports